module.exports = __webpack_public_path__ + "img/Element2_Fehler_Ziffernrechnen.0182ccaf.png";